import { GREEN, AMBER, RED } from '../constants/colors';

// Gauge uses a true semicircle: M10,68 A50,50 0 0,1 110,68
// Center (60,68), radius 50. Arc sweeps 180°, total length = π*50 ≈ 157.08
// Needle pivots from (60,68). Angle: π at score=0 (left), 0 at score=100 (right).
// At score=25: angle=135° → tip (27.5, 35.5) ✓
// At score=50: angle=90°  → tip (60, 22)      ✓  (straight up)
// At score=78: angle=39.6°→ tip (95.4, 38.7)  ✓
// dasharray=(score/100)*157 starts from left endpoint, fills clockwise — synced with needle.

const TOTAL_LEN = Math.PI * 50; // 157.08

export default function Gauge({ score, scale=1 }) {
  const s = Math.round(Math.min(96, Math.max(5, score)));
  const CX = 60, CY = 68;
  const angle = Math.PI * (1 - s / 100);   // π→0 as score 0→100
  const nx = CX + 46 * Math.cos(angle);
  const ny = CY - 46 * Math.sin(angle);    // SVG y-down: subtract
  const arcLen = (s / 100) * TOTAL_LEN;
  const color = s < 35 ? GREEN : s < 65 ? AMBER : RED;
  const riskLabel = s < 35 ? 'Low Risk' : s < 65 ? 'Moderate Risk' : 'High Risk';

  return (
    <div style={{ textAlign: 'center' }}>
      <svg viewBox="0 0 120 76" width={Math.round(148*scale)} height={Math.round(88*scale)} style={{maxWidth:'100%',height:'auto'}}>
        {/* Track */}
        <path d="M10,68 A50,50 0 0,1 110,68" fill="none" stroke="#1e3a5f" strokeWidth="12" strokeLinecap="round"/>
        {/* Filled arc — starts at left (score=0), fills clockwise to score position */}
        <path d="M10,68 A50,50 0 0,1 110,68" fill="none" stroke={color} strokeWidth="12" strokeLinecap="round"
          strokeDasharray={`${arcLen.toFixed(2)} ${TOTAL_LEN.toFixed(2)}`}
          style={{ transition: 'stroke-dasharray 1.2s ease, stroke 0.4s ease' }}/>
        {/* Needle: pivot at arc center (60,68), tip at r=46 on the track */}
        <line x1={CX} y1={CY} x2={nx.toFixed(2)} y2={ny.toFixed(2)}
          stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx={CX} cy={CY} r="4.5" fill="#fff" opacity="0.95"/>
        <circle cx={nx.toFixed(2)} cy={ny.toFixed(2)} r="2" fill="#fff" opacity="0.85"/>
      </svg>
      <div style={{ fontSize: 13, fontWeight: 700, color, fontFamily: 'sans-serif', marginTop: -4 }}>
        {s < 35 ? 'Low Risk' : s < 65 ? 'Moderate Risk' : 'High Risk'}
      </div>
      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', fontFamily: 'sans-serif' }}>
        Score: {s}/100
      </div>
    </div>
  );
}
